/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespTradeFreeShippingPromoTile_viewer$ref = any;
export type SbRespPriceTiles_viewer$ref = any;
export type SbRespPriceTiles_viewer = {
    readonly " $fragmentRefs": SbRespTradeFreeShippingPromoTile_viewer$ref;
    readonly " $refType": SbRespPriceTiles_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespPriceTiles_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbRespTradeFreeShippingPromoTile_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '4760440d96086d66ea05dd0069d3c513';
export default node;
